import requiredArgs from "../_lib/requiredArgs/index.js";
import previousDay from "../previousDay/index.js";
/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @param {Date | number} date - the date to start counting from
 * @returns {Date} the previous Friday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */
export default function previousFriday(date) {
  requiredArgs(1, arguments);
  return previousDay(date, 5);
}


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/previousFriday/index.js
// module id = ./node_modules/date-fns/esm/previousFriday/index.js
// module chunks = 1